module.exports = __webpack_public_path__ + "media/images/lb/023-4b90849cb5d25a91cfaf4bff5c863ae7.svg";